// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectSecondary_root__3tmEJ","vLegacy":"SelectSecondary_vLegacy__3HOUi","error":"SelectSecondary_error__1XK1D","disabled":"SelectSecondary_disabled__2c4fa"};